import { useModalState } from "@/contexts/modal/Context.tsx";
import { useNavigate } from "react-router-dom";
import routes from "@/config/routes.ts";
import { useEffect } from "react";
import SadEmojiIcon from "@/components/icons/SadEmojiIcon.tsx";

interface BookingErrorModalState {
  countCorrections?: number;
  countBookedCorrections?: number;
  hoursWriting: number;
  bookingError?: boolean;
  error: number;
}

export default function BookingErrorModal() {
  const { data } = useModalState();

  const {
    countCorrections,
    countBookedCorrections,
    hoursWriting,
    bookingError,
    error = 2,
  } = data as BookingErrorModalState;

  const navigate = useNavigate();

  useEffect(() => {
    if (countBookedCorrections && countBookedCorrections > hoursWriting) {
      setTimeout(() => {
        navigate(routes.exercises);
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="flex flex-col gap-4 justify-center items-center h-full">
        <div className={"flex flex-col justify-center items-center w-full"}>
          <div
            className={"space-y-2 flex flex-col justify-center items-center"}
          >
            <SadEmojiIcon className={"w-16 h-16 fill-brand-deep"} />
            <h3
              className={
                "text-brand-secondary text-4xl font-semibold pt-3 text-center"
              }
            >
              You can&apos;t book <br /> a live correction
            </h3>
          </div>
        </div>
        <div className="flex flex-col items-center gap-2">
          <p className={"text-center text-brand text-lg font-normal"}>
            {error && error === 1 ? (
              <>You need to do at least writing exercises</>
            ) : bookingError ? (
              <>
                {/* You have booked 2 live corrections for <br />
                this month. You will be able to book other <br />
                sessions in the following month */}
                You have booked {countBookedCorrections} live corrections for{" "}
                <br />
                this period. Contact us for assistance.
              </>
            ) : (
              <>
                {/* You have completed 2 live corrections for <br />
                this month. You will be able to book other <br />
                sessions in the following month */}
                You have completed {countCorrections} live corrections for{" "}
                <br />
                this period. Contact us for assistance.
              </>
            )}
          </p>
          {bookingError ? (
            <div
              className={
                "w-40 h-12 border border-brand-secondary font-semibold text-3xl rounded-lg flex justify-center items-center"
              }
            >{`${countBookedCorrections} / ${hoursWriting}`}</div>
          ) : (
            <div
              className={
                "w-40 h-12 border border-brand-secondary font-semibold text-3xl rounded-lg flex justify-center items-center"
              }
            >{`${countCorrections} / ${hoursWriting}`}</div>
          )}
          <p
            className={
              "text-15px text-center font-semibold text-brand-secondary"
            }
          >
            {error && error === 1 ? (
              <>writing exercise done</>
            ) : bookingError ? (
              <>booked corrections</>
            ) : (
              <>live corrections done</>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
